import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'guitar-electric',
  size: 24,
  node: [
    ['path', { d: 'm12.172 11.828 4.242-4.242', key: '2r10qn' }],
    [
      'path',
      {
        d: 'M16.414 7.586A2 2 0 0017 6.172V5a2 2 0 011.177-1.823L20.59 2.09a1 1 0 011.32 1.32l-1.088 2.412A2 2 0 0119 7h-1a2 2 0 00-1.586.586',
        key: '1s41e7',
      },
    ],
    ['path', { d: 'm6 16 2 2', key: '16qmzd' }],
    [
      'path',
      {
        d: 'M8.23 9.85a3 3 0 011.28-1.454 1 1 0 011.496.815 4 4 0 003.783 3.783 1 1 0 01.815 1.496 3 3 0 01-1.454 1.28l-.92.38A2 2 0 0012 18a4 4 0 01-4 4 6 6 0 01-6-6 4 4 0 014-4 2 2 0 001.85-1.23z',
        key: 'lfhfey',
      },
    ],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name GuitarElectric
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTIuMTcyIDExLjgyOCA0LjI0Mi00LjI0MiIgLz4KICA8cGF0aCBkPSJNMTYuNDE0IDcuNTg2QTIgMiAwIDAwMTcgNi4xNzJWNWEyIDIgMCAwMTEuMTc3LTEuODIzTDIwLjU5IDIuMDlhMSAxIDAgMDExLjMyIDEuMzJsLTEuMDg4IDIuNDEyQTIgMiAwIDAxMTkgN2gtMWEyIDIgMCAwMC0xLjU4Ni41ODYiIC8+CiAgPHBhdGggZD0ibTYgMTYgMiAyIiAvPgogIDxwYXRoIGQ9Ik04LjIzIDkuODVhMyAzIDAgMDExLjI4LTEuNDU0IDEgMSAwIDAxMS40OTYuODE1IDQgNCAwIDAwMy43ODMgMy43ODMgMSAxIDAgMDEuODE1IDEuNDk2IDMgMyAwIDAxLTEuNDU0IDEuMjhsLS45Mi4zOEEyIDIgMCAwMDEyIDE4YTQgNCAwIDAxLTQgNCA2IDYgMCAwMS02LTYgNCA0IDAgMDE0LTQgMiAyIDAgMDAxLjg1LTEuMjN6IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/guitar-electric
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GuitarElectric = createLucideIcon(__iconData);

export default GuitarElectric;
